import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import { TextConstants } from '../../../Common/TextConstants';
import SecurityTransferLookup from '../Models/Lookups/SecurityTransferLookup';

@NeoModel
export default class ManageSecurityTransferComponentVM extends Views.ViewModelBase {

    constructor(
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public clientAccountApiClient = AppService.get(Types.ApiClients.ClientAccountApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public managedSecurityTransfer = new SecurityTransferLookup();
    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public transferSwitchLabel = TextConstants.Labels.InternalTransfer;

    public async initialise() {
       await this.loadFileGroupings();
       this.onInternalTransferSwitchChanged();
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
    }

    //OnSwitchChange Function to update the label
    public onInternalTransferSwitchChanged() {
        this.transferSwitchLabel = this.managedSecurityTransfer.isExternalInd ?
        TextConstants.Labels.ExternalTransfer : TextConstants.Labels.InternalTransfer;
    }

    //Empties the account number, client name and client Account from each time the from broker changes
    public async StockBrokerDropDownOnClicked() {
        this.managedSecurityTransfer.brokerAccountFrom = "";
        this.managedSecurityTransfer.clientName = "";
    }

    //auto populated the client number and name each time the account from is updated
    public async accountDropDownClicked(){
        var clientNameNumber = await this.clientAccountApiClient.getClientNameAndNumber(this.managedSecurityTransfer.accountFrom)
        const data = clientNameNumber.data as any;
        this.managedSecurityTransfer.clientPolicyNumber = data[TextConstants.PlaceHolder.ClientNumber];
        this.managedSecurityTransfer.clientName = data[TextConstants.PlaceHolder.ClientName];
    }
}